module.exports = __webpack_public_path__ + "static/media/ROAD.64ec2286.jpg";